
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 6a6 6 0 1112 0 6 6 0 01-12 0zm14.002 8h-1.107l-6.222 12.633L19 15l-3-3-3 3 2.327 11.633L9.105 14H7.998C4 14 4 16.687 4 20v10h24V20c0-3.313 0-6-3.998-6z"}})])
          )
        }
      }
    